seedWebApp.controller('MbfAdditionalsController', ['$scope', '$uibModal', 'PricesService', 'TranslationService', function ($scope, $uibModal, PricesService, TranslationService) {
    $scope.translation = TranslationService.getActiveTranslation();

    //customClass: function () { return 'agp-color'; }

    console.log('MbfAdditionals');

    $scope.storageClass = function () {
        return 'sd-storage';
    };

    $scope.columns = [        
        { name: 'AdditionalID', display: $scope.translation.ID, filterOptions: [], width: 5, customClass: $scope.storageClass, isKey: true },
        { name: 'AdditionalName', display: 'Nome', filterOptions: [], width: 20 },
        { name: 'AdditionalValue', display: 'Valor', dataType: 'number', currencyFormat: 'R$', filterOptions: [], width: 5, customClass: $scope.qtStockClass },
        { name: 'UnitID', display: 'Unid', filterOptions: [], width: 5 },
    ];

    $scope.prefs = {
        name: 'AdditionalsGrid',
        selContact: null,
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false
    };

    $scope.loadService = PricesService.getMBFAdditionals;
    $scope.loadColumns = PricesService.getPricesColumns;    
    $scope.resetService = PricesService.resetCache;

    $scope.loadTotal = function () {
        $scope.loadingTotal = true;
        PricesService.getPricesCount().then(function (response) {
            $scope.loadingTotal = false;
            $scope.totalItems = response.data;
        });
    };

    $scope.loadTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'Precos_Midea');
    };

    //$scope.prefs.customEdit = function (item) {
    //    var modalInstance = $uibModal.open({
    //        templateUrl: './SPA/Prices/pricesModal.html',
    //        controller: 'PricesModalCtrl',
    //        size: 'md',
    //        resolve: {
    //            materialID: function () {
    //                return item.MaterialID;
    //            }
    //        }
    //    });
    //    modalInstance.result.then(function () {
    //        $scope.doRefresh();
    //    });
    //};

}]);